<template>
  <div>
    <Head />
    <div class="hotspot clear">
      <Nav ms="/Message" />
      <div class="H-right">
        <div class="title">消息中心</div>

        <div class="H-header">
          <select v-model="selStatus" @change="getMsg()">
            <option value>全部</option>
            <option value="0">注册消息</option>
            <option value="1">成果消息</option>
          </select>
        </div>
        <div class="t_main">
          <el-table
            border
            :header-cell-style="{'background-color': '#001743','color': '#fff','height':'0.5rem'}"
            :stripe="true"
            :data="tableData1"
            style="width: 100%;"
            :row-style="{'height':'0.4rem'}"
            :default-sort="{prop: 'time', order: 'descending'}"
          >
            <el-table-column
              width="50"
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              width="500"
              prop="content"
              label="消息内容"
              header-align="center"
              align="center"
            ></el-table-column>
            <!-- <el-table-column  prop="type_msg"  label="消息类型" header-align="center" align="center"></el-table-column> -->
            <el-table-column
              prop="datetime"
              label="发送时间"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  v-if="scope.row.status==0&&scope.row.content.indexOf('中国煤炭行业协会的审核')==-1"
                  @click="toBgjurisdiction(scope.row.type)"
                >处理</el-button>
                <el-button
                  size="mini"
                  type="success"
                  v-if="scope.row.status==0&&scope.row.content.indexOf('中国煤炭行业协会的审核')!=-1"
                  @click="toBgjurisdiction(scope.row)"
                >确认</el-button>
                <!-- <el-button
                  size="mini"
                  v-if="scope.row.Status==1"
                  @click="setInfo(2,scope.row)"
                  type="danger"
                >禁用</el-button>
                <el-button
                  size="mini"
                  v-if="scope.row.Status==2"
                  @click="setInfo(1,scope.row)"
                  type="primary"
                >启用</el-button>-->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right;height: 0.45rem;"
            v-if="tableData1.length>0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  data() {
    return {
      total1: 1,
      Page1: 1,
      value: "1",
      PageSize1: 10,
      tableData1: [],
      selStatus: ""
    };
  },
  created() {
    this.getMsg();
  },
  methods: {
    getMsg() {
      this.$axios
        .post(
          "message/index?token=" + sessionStorage.getItem("token"),
          this.$qs.stringify({
            type: this.selStatus,
            page: this.Page1,
            num: this.PageSize1
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data.data.list);
            if (res.data.data.list) {
              this.tableData1 = res.data.data.list;
              this.total1 = res.data.data.total_num;
            } else {
              this.tableData1 = [];
            }
          } else {
            this.$message({
              message: res.data.msg
            });
          }
        });
    },
    toBgjurisdiction(type) {
      // this.$axios.post("message/updatestatus?ID=" + ID +"&token="+sessionStorage.getItem("token")).then(res => {
      //   if (res.data.code == 10000) {
      if (type == 0) {
        this.$router.replace("/Bgjurisdiction");
      } else if (type == 1) {
        this.$router.replace("/Bgreviewone");
      } else {
        this.$axios
          .post(
            "message/updatestatus",
            this.$qs.stringify({
              type: 1,
              ReportID: type.address,
              token: sessionStorage.getItem("token")
            })
          )
          .then(res => {
            if (res.data.code == 10000) {
              this.getMsg();
            } else {
              this.$message({
                type: "warning",
                message: res.data.msg
              });
            }
          });
      }

      //   }
      // });
    },
    formatter(row, column) {
      console.log(column);
      return row.address;
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      this.getMsg();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      this.getMsg();
    }
  },
  components: {
    Head,
    Foot,
    Nav
  }
};
</script>

<style scoped lang="less">
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.btn {
  width: 1rem;
  cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.17rem;
  text-align: center;
  background: #409eff;
  border-radius: 0.04rem;
  color: #fff;
}
.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;
  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;
    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }
    .H-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 0.5rem;
      span,
      select,
      div,
      input {
        margin-right: 0.2rem;
      }
      input,
      select {
        height: 0.4rem;
        width: 2rem;
        padding: 0.05rem;
      }
    }
  }
}
.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10.11rem;

    background: white;
    font-size: 0.16rem;
    .f-top {
      height: 0.5rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;
      border-bottom: 1px #cfcfcf solid;
      img {
        position: absolute;
        right: 0.1rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .f-info {
      padding: 0 0.54rem;
      .f-title {
        position: relative;
        overflow: hidden;
        padding-bottom: 0.5rem;
        border-bottom: 1px #cfcfcf solid;
        .f-left {
          overflow: hidden;
          position: relative;
          > img {
            margin-left: 1.2rem;
          }
          > div {
            margin: 0.3rem 0.18rem;
            vertical-align: top;
            > span {
              width: 0.8rem;
              text-align: justify;
              text-align-last: justify;
              color: #505050;
              display: inline-block;
            }
            > a {
              color: #505050;
              font-style: normal;
            }
            > em {
              margin-left: 0.3rem;
              color: #272727;
              font-style: normal;
            }
          }
        }
        .f-right {
          position: absolute;
          top: 0;
          right: 0;
          width: 50%;
        }
      }
      .f-bottom {
        margin: 0.2rem 0.2rem;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>